var data = { colors:{ common:{ black:"#000",
      white:"#fff" },
    navy:{ "400":"#F5F7FA",
      "500":"#E3E8EE",
      "600":"#B8C5D5",
      "700":"#7F96B4",
      "800":"#627EA3",
      "900":"#475D7A" },
    gray:{ "200":"#FAFAFA",
      "300":"#F5F5F5",
      "400":"#E8E8E8",
      "500":"#D9D9D9",
      "600":"#BFBFBF",
      "700":"#8C8C8C",
      "800":"#595959",
      "900":"#262626" },
    green:{ "300":"#E1F1D9",
      "500":"#389E0D",
      "700":"#237804" },
    orange:{ "300":"#FDF8E9",
      "500":"#F19953",
      "700":"#B95E06" },
    red:{ "300":"#FFE7E3",
      "400":"#EA9486",
      "500":"#DD7C6C",
      "600":"#CD4631",
      "700":"#B82A13" },
    brand:{ blue:"#2F7699",
      red:"#FF585D",
      navy:"#475D7A",
      deepNavy:"#253746",
      lightGray:"#E5E1E5",
      darkGray:"#434143" },
    overlay:"rgba(0, 0, 0, 0.65)",
    shadow:"rgba(0, 0, 0, 0.65)",
    primary:{ "400":"#F5F7FA",
      "500":"#E3E8EE",
      "600":"#B8C5D5",
      "700":"#7F96B4",
      "800":"#627EA3",
      "900":"#475D7A" },
    accent:{ "200":"#FAFAFA",
      "300":"#F5F5F5",
      "400":"#E8E8E8",
      "500":"#D9D9D9",
      "600":"#BFBFBF",
      "700":"#8C8C8C",
      "800":"#595959",
      "900":"#262626" } } };

export default data;
//# sourceMappingURL=colors.yaml.js.map
